import * as actions from 'actions';

const INITIAL_STATE = {
  isPasswordUpdating: false,
  serverPasswordError: ''
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.USER_UPDATE: {
      return {
        ...state,
        isPasswordUpdating: true
      };
    }

    case actions.USER_UPDATE_SUCCESS: {
      return {
        ...state,
        isPasswordUpdating: false,
        serverPasswordError: ''
      };
    }
    case actions.USER_UPDATE_ERROR: {
      return {
        ...state,
        isPasswordUpdating: false,
        serverPasswordError: action.error ? action.error.message: ''
      };
    }

    case actions.USER_UPDATE_RESET: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/user/passwordUpdate/reducer.js
 **/